
class IdleX{

  /**
   * Idle for n milliseconds
   * @param {Number} ms 
   */
  static async Sleep(ms){
    return new Promise( res => setTimeout(res, ms) );
  }
}

export default IdleX;